import { isOnOrigin } from '@app/shared'

/** Where a sign-in link lands. The API builds exactly this (`auth.service`). */
export const MAGIC_LINK_PATH = '/auth/verify'

/**
 * The path to return to after a sign-in, from the address the person is on.
 *
 * `/auth/verify` is not a landing — it holds a token — so a sign-in that
 * happened there returns to the root. Anything the origin guard refuses is
 * the root too, so a crafted pathname cannot become a redirect off this site.
 */
export function returnPath(here: {
  pathname: string
  search: string
  origin: string
}): string {
  if (here.pathname === MAGIC_LINK_PATH) return '/'
  const candidate = `${here.pathname}${here.search}`
  return isOnOrigin(candidate, here.origin) ? candidate : '/'
}
